'use strict';

const debounce = require('lodash/debounce');
const wishlist = require('../../product/wishlist');
const toaster = require('../../components/toaster');

/**
 * Initializes Slick sliders for elements with the class `shop-the-look-carousel`.
 */
function shopTheLookSlickInit() {
    $('.shop-the-look-carousel').each(function () {
        var $this = $(this);
        const $container = $this.closest('.shop-the-look-carousel-container');
        const containerData = $container.data();

        const slidesToShowDesktop = containerData.slides.desktop || 4;
        const slidesToShowTablet = containerData.slides.tablet || 3;
        const slidesToShowMobile = containerData.slides.mobile || 1;
        let enableDots = false;
        var isinitializeOnAllDevice = true;
        var centerMode = false;
        let enableInfinite = false;
        let centerPadding = '0px';
        let initialSlide = 0;
        if ($container.hasClass('brand-aal')) {
            isinitializeOnAllDevice = false;
            let carouselConfig = {};
            try {
                carouselConfig = JSON.parse($container.attr('data-carousel-config'));
            } catch (error) {
                carouselConfig = {};
            }

            if ($container.hasClass('product')) {
                centerMode = true;
                centerPadding = (carouselConfig && carouselConfig.centerPadding) || '0px';
                initialSlide = (carouselConfig && carouselConfig.initialSlide) || 1;
            }

            enableInfinite = carouselConfig.infinite || false;
        }
        if ($container.hasClass('brand-mtb') && $container.find('.shop-the-look-carousel-component__products-full-cta').children().length === 0) {
            enableDots = true;
        }
        if ($container.hasClass('brand-mtb') && $container.find('.shop-the-look-carousel-component__tiles').children().length > 0) {
            let titleCarousel = $container.find('.shop-the-look-carousel-component__title .title-mtb').text().replace(/\n/g, '').trim();
            let itemListName;
            let ecommerceObj = {
                items: [],
            };

            let viewItemEventData = {
                category: 'Product',
                event: 'view_item_list',
                name: 'Shop the Look',
                reference: 'rKPI_P2.1',
            };
            setTimeout(() => {
                $container.find('.shop-the-look-carousel-component__tiles .slick-slide .product-tile-pd').each(function () {
                    var data = $(this).data();
                    if (data.trackingEventPayload) {
                        ecommerceObj.currency = data.trackingEventPayload.ecommerce.currency;
                        itemListName = data.trackingEventPayload.ecommerce.items[0].item_list_name.split(':');
                        data.trackingEventPayload.ecommerce.items[0].item_list_name = 'Shop the Look - ' + titleCarousel + itemListName[1];
                        ecommerceObj.items.push(data.trackingEventPayload.ecommerce.items[0]);
                    }
                });
                if ($('.shop-the-look-carousel-component__tiles .slick-slide .product-tile-pd').length) {
                    viewItemEventData.ecommerce = ecommerceObj;
                    if (window.dataLayer) {
                        window.dataLayer.push(viewItemEventData);
                    }
                }
            }, 500);
        }

        var sliderSeting = {
            centerPadding: centerPadding,
            dots: enableDots,
            arrows: true,
            infinite: false,
            speed: 500,
            touchThreshold: 100,
            slidesToShow: slidesToShowDesktop,
            slidesToScroll: 1,
            nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-hover icon-size-xl"></i></button>',
            prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-hover icon-size-xl"></i></button>',
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: slidesToShowTablet,
                        slidesToScroll: 1,
                        dots: enableDots,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: slidesToShowMobile,
                        slidesToScroll: 1,
                        dots: enableDots,
                    },
                },
            ],
        };
        if (!isinitializeOnAllDevice) {
            sliderSeting = {
                centerPadding: centerPadding,
                dots: enableDots,
                arrows: true,
                infinite: enableInfinite,
                speed: 500,
                touchThreshold: 100,
                slidesToShow: slidesToShowDesktop,
                centerMode: centerMode,
                slidesToScroll: 1,
                nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-hover icon-size-xl"></i></button>',
                prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-hover icon-size-xl"></i></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: slidesToShowMobile,
                            slidesToScroll: 1,
                            dots: enableDots,
                            initialSlide: initialSlide,
                        },
                    },
                    {
                        breakpoint: 9999,
                        settings: 'unslick',
                    },
                ],
            };
        }
        if (!$this.hasClass('slick-initialized')) {
            $this.css('width', $this.width() + 'px');
            $this.slick(sliderSeting);
        }

        setTimeout(() => {
            var $arrowTop = $this.find('.product-tile-component-image').first().height() / 2;
            $this.find('.slick-next, .slick-prev').css('top', $arrowTop + 'px');
        }, 100);
    });
}

/**
 * Toggles the visibility of add-to-wishlist and remove-from-wishlist buttons
 * for shop-the-look components.
 */
function toggleWishlistButtons() {
    const $shopTheLookComponents = $('.shop-the-look-component');
    const savedWishlistProducs = wishlist.methods.getWishlistFromStorage();

    for (let i = 0; i < $shopTheLookComponents.length; i++) {
        const $element = $shopTheLookComponents.eq(i);
        const $addToWishList = $element.find('.add-to-wish-list-link');
        const $removeFromWishList = $element.find('.remove-from-wish-list-link');
        const $productLinks = $element.find('.product-tile a');
        let pidArray = [];

        for (let x = 0; x < $productLinks.length; x++) {
            const $productLink = $productLinks.eq(x);
            const currentPid = $productLink.data('pid');

            pidArray.push(currentPid);
        }
        const includedAllProducts = pidArray.every(function (element) {
            return savedWishlistProducs.includes(element);
        });
        $addToWishList.toggleClass('d-none', includedAllProducts);
        $removeFromWishList.toggleClass('d-none', !includedAllProducts);
    }
}

/**
 * Initialize the wishlist functionality
 */
function initWishlist() {
    toggleWishlistButtons();

    $('.remove-from-wish-list-link').on('click', function (e) {
        e.preventDefault();
        const $toaster = $(this).parents('.product-wrapper').find('.remove-from-wishlist-modal');

        toaster.openToaster($toaster);
        toaster.closeToasterEvents($toaster);
    });

    $('.remove-from-wishlist-modal .close, .remove-from-wishlist-modal .cancel-btn, .successful-add-to-wishlist-modal .close, .successful-add-to-wishlist-modal .cancel-btn').on(
        'click',
        function () {
            const $this = $(this);
            const $parent = $this.parents('.toaster');

            toaster.closeToaster($parent);
        }
    );

    $('.add-to-wish-list-link, .delete-all-from-wishlist').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $parent = $this.parents('.product-wrapper');
        const $removeFromWishlist = $parent.find('.remove-from-wish-list-link');
        const $removeConfirmFromWishlist = $parent.find('.delete-all-from-wishlist');
        const $addToWishlist = $parent.find('.add-to-wish-list-link');
        const isRemoveFromWishlist = $this.is($removeConfirmFromWishlist);
        const url = $this.attr('href');
        const $productLinks = $parent.find('.product-tile a');
        let pidArray = [];

        for (let i = 0; i < $productLinks.length; i++) {
            const $element = $productLinks.eq(i);
            const currentPid = $element.data('pid');

            pidArray.push(currentPid);
        }

        $.ajax({
            type: 'POST',
            url,
            data: `pid=${pidArray.join(',')}`,
            success(data) {
                if (!data.error) {
                    $addToWishlist.toggleClass('d-none', !isRemoveFromWishlist);
                    $removeFromWishlist.toggleClass('d-none', isRemoveFromWishlist);

                    if (!isRemoveFromWishlist) {
                        const $wishlistAddedModal = $('.successful-add-to-wishlist-modal').eq(0);
                        const productSetName = $parent.find('.product-name p').text();
                        for (let i = 0; i < pidArray.length; i++) {
                            const pid = pidArray[i];

                            wishlist.methods.addProductToWishlistStorage(pid);
                        }

                        $wishlistAddedModal.find('.pdp-image-item').detach();
                        $wishlistAddedModal.find('.product').text(productSetName);
                        toaster.openToaster($wishlistAddedModal);
                        toaster.closeToasterEvents($wishlistAddedModal);
                    } else {
                        $this.parents('.modal').modal('hide');
                        for (let i = 0; i < pidArray.length; i++) {
                            const pid = pidArray[i];

                            wishlist.methods.removeProductFromWishlistStorage(pid);
                        }

                        toaster.closeToaster($('.remove-from-wishlist-modal.toaster-animate'));
                    }
                    toggleWishlistButtons();
                }
            },
        });
    });
}

$(document).ready(function () {
    setTimeout(() => {
        shopTheLookSlickInit();
    }, 100);
    $(window).resize(debounce(shopTheLookSlickInit, 300));
    initWishlist();
});
